// Package Imports
import { useSimpleList } from '@refinedev/antd';
import { BaseRecord, useTranslate } from '@refinedev/core';
import dayjs from 'dayjs';
// Project Imports
import { useRulesContext } from 'contexts/rulesContext/RulesContext';
import apiEndpoint from 'core/common/apiEndPoints';
import resourceName from 'core/common/resourceName';

import replacePipe from 'core/utils/replacePipe';

export function ruleGroupApiResponse(pageType) {
  const { rulePlanDataObj } = useRulesContext();
  const t = useTranslate();
  const { listProps, queryResult } = useSimpleList({
    resource: `${pageType === 'Show' && rulePlanDataObj?.view_unique_id ? apiEndpoint.ruleGroup : apiEndpoint.ruleGroupDraft}`,
    pagination: {
      mode: 'off',
    },
    filters: {
      permanent: [
        {
          field: 'rule_plan',
          operator: 'in',
          value:
            pageType === 'Show'
              ? rulePlanDataObj.view_unique_id
              : rulePlanDataObj?.edit_unique_id,
        },
      ],
    },
    queryOptions: {
      enabled: !!rulePlanDataObj?.unique_id,
    },
    errorNotification: (data: BaseRecord) => {
      const message =
        replacePipe(data?.message) || t('notifications.errorMessage');
      return {
        message: 'Error Message',
        description: message,
        type: 'error',
      };
    },
  });
  const ruleGroupList = (listProps?.dataSource as any)?.results;
  const { isFetching } = queryResult;
  return { ruleGroupList, isFetching };
}

export function getRuleType(ruleGroupData, ruleGroupId) {
  const selectedRuleGroupObj = ruleGroupData?.find(
    (item) => item?.unique_id === ruleGroupId
  );
  return selectedRuleGroupObj?.rule_type;
}

export function getDateRange(ruleGroupData, ruleGroupId) {
  const selectedRuleGroupObj = ruleGroupData?.find(
    (item) => item?.unique_id === ruleGroupId
  );
  const startDate = dayjs(selectedRuleGroupObj?.rule_group_start_date);
  const endDate = dayjs(selectedRuleGroupObj?.rule_group_end_date)
    ?.hour(23)
    .minute(59)
    .second(59);
  return [startDate, endDate];
}

export function getUnifiedList(params?: { filterType?: string }) {
  const { rulePlanDataObj } = useRulesContext();
  const t = useTranslate();

  const { listProps: unifiedOptions } = useSimpleList({
    dataProviderName: 'unifiedDataProvider',
    resource: `${apiEndpoint.dataSourceColumnList}/?id=${rulePlanDataObj?.unified_source_master_id}&source_type=unified`,
    meta: {
      type: 'select',
    },
    pagination: {
      mode: 'off',
    },
    errorNotification: (data: BaseRecord) => {
      const message =
        replacePipe(data?.message) || t('notifications.errorMessage');
      return {
        message: 'Error Message',
        description: message,
        type: 'error',
      };
    },
  });
  const responseData = (unifiedOptions?.dataSource as any)?.column_list;
  const unifiedList = responseData?.map((item) => ({
    label: item.label,
    value: item.unique_id,
  }));
  return params?.filterType === 'unfiltered' ? responseData : unifiedList;
}

export function getDmnXmlString(id, fileType, pageType) {
  const { rulePlanDataObj } = useRulesContext();
  const { listProps: dmnXMlString } = useSimpleList({
    resource: `${apiEndpoint.getDmnXmlString}/${id}/?rule_type=${pageType === 'Show' && rulePlanDataObj.view_unique_id ? 'main' : 'draft'}`,
    pagination: {
      mode: 'off',
    },
    queryOptions: {
      enabled: !!id && fileType === 'dmn',
    },
  });
  const dmnXmlList = (dmnXMlString?.dataSource as any)?.results;
  return { dmnXmlList };
}

export function getDmnOutputVariableList(id, rulePlanId, hasShow) {
  const { rulePlanDataObj } = useRulesContext();
  const {
    listProps: dmnOutputVariable,
    queryResult: { refetch: dmnOpVarListRefetch },
  } = useSimpleList({
    resource: `${apiEndpoint.getOutputVariableList}/${rulePlanId}/${id}/?rule_type=${hasShow && rulePlanDataObj?.view_unique_id ? 'main' : 'draft'}`,
    pagination: {
      mode: 'off',
    },
    queryOptions: {
      enabled: !!id,
    },
  });
  const dmnOutputList = (dmnOutputVariable?.dataSource as any)?.results;
  return { dmnOutputList, dmnOpVarListRefetch };
}
export function onSelectRuleGroupfn(
  e,
  ruleGroupList,
  form,
  allowEdit,
  ruleData
) {
  const selectedRuleGroupObj = ruleGroupList?.find(
    (item) => item?.unique_id === e
  );
  const startDate = dayjs(selectedRuleGroupObj?.rule_group_start_date);
  const endDate = dayjs(selectedRuleGroupObj?.rule_group_end_date);
  form.setFieldsValue({
    rules_date: [startDate, endDate],
    rule_applicability_editor_type: 'wizard',
    payout_applicability_editor_type: 'wizard',
    output_formula_editor_type: 'wizard',
  });
  if (allowEdit) {
    form.setFieldsValue({
      payout_applicability:
        ruleData?.payout_applicability &&
        typeof ruleData?.payout_applicability === 'object'
          ? ''
          : ruleData?.payout_applicability,
      rule_applicability:
        ruleData?.rule_applicability &&
        typeof ruleData?.rule_applicability === 'object'
          ? ''
          : ruleData?.rule_applicability,
      output_formula:
        ruleData?.output_formula && typeof ruleData?.output_formula === 'object'
          ? ''
          : ruleData?.output_formula,
    });
  }
}

export function getHandleClick(form, setOpenModal, list) {
  function getVariableFieldNameList(formData, keys) {
    keys?.forEach((element) => {
      /* eslint-disable no-param-reassign */
      delete formData[element];
    });
    return Object.keys(formData);
  }
  const variableFieldNameList = getVariableFieldNameList(
    form.getFieldsValue(),
    [
      'rules_date',
      'rule_is_active',
      'output_formula_mode_type',
      'rule_applicability_mode_type',
      'payout_applicability_mode_type',
      'payout_applicability_editor_type',
      'rule_applicability_editor_type',
      'output_formula_editor_type',
    ]
  );
  function isUnsavedChnages(formData) {
    return Object.keys(formData).some(
      (key) => formData[key] !== undefined && formData[key] !== ''
    );
  }
  const handleClick = () => {
    if (isUnsavedChnages(form.getFieldsValue(variableFieldNameList))) {
      setOpenModal(true);
    } else {
      list(resourceName.rulePlans);
    }
  };
  return handleClick;
}
